module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'schoolVacation',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {
            statusFlagsSummary: true,
            customer: true,
            terms: true,
        },
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '100px',
        },
        rowActions: {
            edit: true,
            customs: [
                {
                    buttonType: 'delete',
                    neutral: true,
                },
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bosch_schoolVacation': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'schoolVacationID',
                direction: 'desc'
            }]
        }
    },

    methods: {
        onBuild(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true }
                ]
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers 	= this.config.heartbeatRefreshOn || {}
            const key 			= message.heartbeatKey

            if(refreshers[key] && (
                (key === 'reconnect') ||
                (key === 'resourceChanged.bosch_schoolVacation')
            )){
                this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    },
}